const IOS_NO_FOCUS_ZOOM_STYLE_ID = "lex-ios-no-focus-zoom";

const IOS_NO_FOCUS_ZOOM_CSS = `
@media (max-width: 1024px), (hover: none) and (pointer: coarse) {
  html body #root input:not([type]),
  html body #root input[type="text"],
  html body #root input[type="email"],
  html body #root input[type="password"],
  html body #root input[type="search"],
  html body #root input[type="tel"],
  html body #root input[type="url"],
  html body #root input[type="number"],
  html body #root input[type="date"],
  html body #root input[type="datetime-local"],
  html body #root input[type="month"],
  html body #root input[type="week"],
  html body #root input[type="time"],
  html body #root textarea,
  html body #root select,
  html body #root [contenteditable="true"] {
    font-size: 16px !important;
    -webkit-text-size-adjust: 100%;
  }
}
`;

function ensureNoFocusZoomStyleLast() {
  if (typeof document === "undefined" || !document.head) return;

  let style = document.getElementById(IOS_NO_FOCUS_ZOOM_STYLE_ID);
  if (!style) {
    style = document.createElement("style");
    style.id = IOS_NO_FOCUS_ZOOM_STYLE_ID;
    style.setAttribute("data-lex-global-guard", "ios-no-focus-zoom");
    style.textContent = IOS_NO_FOCUS_ZOOM_CSS;
  } else if (style.textContent !== IOS_NO_FOCUS_ZOOM_CSS) {
    style.textContent = IOS_NO_FOCUS_ZOOM_CSS;
  }

  if (document.head.lastElementChild !== style) {
    document.head.appendChild(style);
  }
}

if (typeof window !== "undefined") {
  ensureNoFocusZoomStyleLast();

  window.addEventListener("focusin", ensureNoFocusZoomStyleLast, true);
  window.addEventListener("load", ensureNoFocusZoomStyleLast, { once: true });

  window.requestAnimationFrame?.(ensureNoFocusZoomStyleLast);
  window.setTimeout?.(ensureNoFocusZoomStyleLast, 0);
  window.setTimeout?.(ensureNoFocusZoomStyleLast, 1000);

  if (typeof MutationObserver === "function" && document.head) {
    const observer = new MutationObserver(() => ensureNoFocusZoomStyleLast());
    observer.observe(document.head, { childList: true });
  }
}
